import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./header-info.css";

const TOOLTIP_WIDTH_PX = 280;

// An ⓘ in a table header explaining the column. The explanation is drawn in document.body at
// a fixed position: inside the table it would be cut off, since tables like these scroll
// inside their own box with the header stuck to its top. Opens on hover, keyboard focus and
// tap, and a click on it does not sort the column it sits in.
export default function HeaderInfo({ text }) {
  const iconRef = useRef(null);
  const [position, setPosition] = useState(null);

  const open = () => {
    const rect = iconRef.current.getBoundingClientRect();
    const left = Math.min(
      Math.max(8, rect.left + rect.width / 2 - TOOLTIP_WIDTH_PX / 2),
      window.innerWidth - TOOLTIP_WIDTH_PX - 8
    );
    setPosition({ top: rect.bottom + 8, left });
  };
  const close = () => setPosition(null);

  // Fixed to where the icon was: once anything scrolls, it would be pointing at nothing.
  useEffect(() => {
    if (!position) return;
    window.addEventListener("scroll", close, { capture: true, passive: true });
    return () => window.removeEventListener("scroll", close, { capture: true });
  }, [position]);

  return (
    <>
      <span
        ref={iconRef}
        className="header-info"
        role="button"
        tabIndex={0}
        aria-label={text}
        onMouseEnter={open}
        onMouseLeave={close}
        onFocus={open}
        onBlur={close}
        onClick={(e) => {
          e.stopPropagation();
          position ? close() : open();
        }}
      >
        ⓘ
      </span>
      {position &&
        createPortal(
          <div
            className="header-info-tooltip"
            role="tooltip"
            style={{ top: position.top, left: position.left, width: TOOLTIP_WIDTH_PX }}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
}
